import ExternalCalendarOptionsPanel from "externalCalendar/ExternalCalendarOptionsPanel";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import { ExternalCalendarActivityPanel } from "./activity/ExternalCalendarActivityPanel";
import { ExternalCalendarDetailSection } from "externalCalendar/ExternalCalendarDetailSection";
import { RefreshLogPanel } from "externalCalendar/RefreshLogPanel/RefreshLogPanel";

const ExternalCalendarDetail = () => {
  const viewModel = useLoaderData<server.viewmodel.ExternalCalendarDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <ExternalCalendarDetailSection
        externalCalendar={viewModel.externalCalendar}
        refreshUrl={viewModel.refreshEndpoint}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <ExternalCalendarOptionsPanel
        externalCalendarId={viewModel.externalCalendar.externalCalendarId}
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
      />

      <ExternalCalendarActivityPanel
        externalCalendarId={viewModel.externalCalendar.externalCalendarId}
        config={viewModel.activityPanelConfig}
      />

      <RefreshLogPanel
        externalCalendarId={viewModel.externalCalendar.externalCalendarId}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default ExternalCalendarDetail;